import { rgba } from 'polished';

import { GapProps } from '@/styles/types';

import { colors } from './themes/colors';
import { fontSizes } from './themes/font-sizes';
import { fontWeights } from './themes/font-weights';
import { radii } from './themes/radii';
import { spaces } from './themes/spaces';

// Font weight mapping function
const mapFontWeights = (weights: typeof fontWeights) => {
  const weightMap: Record<string, number> = {
    W4: 400,
    W6: 600,
  };

  return Object.fromEntries(
    Object.entries(weights).map(([key, value]) => [
      key,
      weightMap[value] || value,
    ])
  );
};

// Media queries
export const mediaQueries = {
  sp: 'screen and (max-width: 640px)',
  portrait: 'screen and (orientation:portrait) and (max-width: 768px)',
  landscape: 'screen and (max-width: 1024px)',
  tablet: 'screen and (max-width: 1300px)',
  pc: 'screen and (min-width: 1301px)',
};

// Gap utility
const gap = (props: GapProps) => ({
  gap: props.gap,
  rowGap: props.rowGap,
  columnGap: props.columnGap,
});

// Line heights
const lineHeights = {
  s: '1',
  m: '1.6',
};

// Borders
const borders = {
  default: `1px solid ${colors.border.default}`,
  strong: `2px solid ${colors.border.strong}`,
  error: `1px solid ${colors.border.error}`,
  focus: `1px solid ${colors.border.focus}`,
  qrCodeFrame: `8px solid ${colors.border.inverse}`,
  tag: `1px solid ${colors.border.focus}`,
};

// Shadows
const shadows = {
  default: `0 0 0 4px ${rgba('#201F1D', 0.25)}`,
};

// Window size
const windowSize = {
  base: '640px',
};

// Opacities
const opacities = {
  disabled: 0.2,
};

// Z-index
const zIndices = {
  header: 100,
  modalOverlay: 1000,
};

export const theme = {
  mediaQueries,
  colors,
  fontWeights: mapFontWeights(fontWeights),
  fontSizes,
  spaces,
  radii,
  lineHeights,
  borders,
  shadows,
  windowSize,
  opacities,
  gap,
  zIndices,
} as const;

export type Theme = typeof theme;
